import { connect } from 'react-redux'
import { compose, withHandlers, withProps, onlyUpdateForKeys } from 'recompose'
import { actions, selectors } from '../../reducers'
import constants from '../../constants'

const mapStateToProps = state => ({
  contentIds: Object.keys(state.collections.content),
  content: state.collections.content,
  defaultContentId: state.collections.defaultContentId,
  selectedContentColor: state.create.selectedContentColor,
  selectingContentType: state.create.selectingContentType,
})

const mapDispatchToProps = {
  fetch: actions.collections.fetch,
  stopListening: actions.collections.stopListening,
  setEventDate: actions.create.setEventDate,
  pushOne: actions.collections.pushOne,
  selectContentColor: actions.create.selectContentColor,
}

const createProps = props => ({
  fetch: () => props.fetch('content'),
  selectedContent:
    props.selectingContentType === constants.createNav.SELECT_CONTENT_TYPE_THEME
      ? props.content[props.selectedContentId]
      : props.selectedContentColor,
})

const handlers = {
  selectNextContentId: props => () =>
    props.selectNextContentId(props.contentIds),
  selectPrevContentId: props => () =>
    props.selectPrevContentId(props.contentIds),
  selectContentId: props => id => props.selectContentId(id),
  scheduleEvent: props => () =>
    props.pushOne({
      collectionName: 'events',
      item: {
        contentId: props.selectedContentId,
        startDate: props.startDate,
        endDate: props.endDate,
      },
    }),
  setStartDate: props => date =>
    props.setEventDate({
      type: 'startDate',
      date: date.toDate().getTime(),
    }),
  setEndDate: props => date =>
    props.setEventDate({
      type: 'endDate',
      date: date.toDate().getTime(),
    }),
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers(handlers),
  withProps(createProps),
  onlyUpdateForKeys([
    'selectedContentColor',
    'isSelectingColor',
    'startDate',
    'endDate',
    'defaultContentId',
    'selectingContentType',
    'selectedContentId',
    'selectedContent',
    'content',
    'check',
  ]),
)



// WEBPACK FOOTER //
// ./src/components/select-content/enhance.js